export const TOKEN_KEY = '@unijob-token';
export const isAuthenticated = () => global.localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => global.localStorage.getItem(TOKEN_KEY);
export const login = token => {
  global.localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
  global.localStorage.removeItem(TOKEN_KEY);
};
